import { render, staticRenderFns } from "./Vehical_master.vue?vue&type=template&id=976168d6&"
import script from "./Vehical_master.vue?vue&type=script&lang=js&"
export * from "./Vehical_master.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports